import { Component, OnInit, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { DatabaseService } from 'src/_services/DatabaseService'
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material';
import { sessionStorage } from '../localstorage.service';
import { FormControl } from '@angular/forms'
import { Chart } from 'chart.js';
import * as Highcharts from 'highcharts/highmaps';
import { DatePipe } from '@angular/common';
import indiaMap from '../../assets/indiaMap';
import { ToastrManager } from 'ng6-toastr-notifications';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [DatePipe]
})


export class DashboardComponent implements OnInit {

  targetTilesData: any = {}
  targetTilesData1: any = {}
  today_date: any = new Date()



  today: any = new Date();
  lastDay: any = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 0).getDate()
  currentDay: any = this.today.getDate()

  financeyear: string;




  topEmployees = [
    {
      name: 'John Doe',
      department: 'Sales',
      avatar: 'path/to/avatar.jpg',
      sales: 125000,
      orders: 45,
      performanceScore: 95,
      isOnline: true
    },
    {
      name: 'John Doe',
      department: 'Sales',
      avatar: 'path/to/avatar.jpg',
      sales: 125000,
      orders: 45,
      performanceScore: 95,
      isOnline: true
    },
    {
      name: 'John Doe',
      department: 'Sales',
      avatar: 'path/to/avatar.jpg',
      sales: 125000,
      orders: 45,
      performanceScore: 95,
      isOnline: true
    },



  ];
  currentIndex = 0;
  isAutoPlaying = true;
  isAnimating = false;
  private autoPlayInterval: any;
  private readonly SLIDE_DURATION = 5000; // 5 seconds

  tabValue: any = 'Sales';
  totalDays: any;
  dayInMonth: any;
  // Top 3 performers data
  topPerformers = [
    {
      id: 1,
      name: 'John Smith',
      role: 'Senior Sales Manager',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face',
      totalSales: '$284,592',
      targetAchievement: '142%'
    },
    {
      id: 2,
      name: 'Sarah Johnson',
      role: 'Marketing Director',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face',
      totalSales: '$198,420',
      targetAchievement: '128%'
    },
    {
      id: 3,
      name: 'Michael Chen',
      role: 'Business Development',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face',
      totalSales: '$176,890',
      targetAchievement: '118%'
    }
  ];

  // Secondary performers data (4-6)
  secondaryPerformers = [
    {
      id: 4,
      name: 'Emily Davis',
      role: 'Account Manager',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face',
      totalSales: '$152,340',
      targetAchievement: '115%'
    },
    {
      id: 5,
      name: 'David Wilson',
      role: 'Product Manager',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&h=80&fit=crop&crop=face',
      totalSales: '$148,230',
      targetAchievement: '112%'
    },
    {
      id: 6,
      name: 'Lisa Brown',
      role: 'Regional Sales Rep',
      avatar: 'https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?w=80&h=80&fit=crop&crop=face',
      totalSales: '$134,580',
      targetAchievement: '108%'
    }
  ];
  detail: any = {};

  months: string[] = [];
  xGap = 60;
  maxY = 0;
  minY = 0;
  yAxisLabels: any[] = [];

  lastYearPoints = '';
  currentYearPoints = '';



  currentDate = new Date();
  secondaryTarget: any = {};
  primaryTarget: any = {};
  checkinCount: any = [];
  checkinCountTotal: any;
  categoryWiseSales: any = [];
  top3PrimaryAchievers: any=[];
  top3SecondaryAchievers: any=[];
  totalEnquiry: any ={};
  totalQualifiedEnquiry: any={};
  sourceWiseConversion: any={};
  sourceWiseConversionTotal: any={};
  constructor(public toast: ToastrManager, public serve: DatabaseService, public dialog: MatDialog, public route: Router, private renderer: Renderer2, public session: sessionStorage) {

    this.detail.lossrate = 25;
    this.getSecondaryTarget();
    this.getPrimaryTarget();
    this.getCheckinCount();
    this.getCategoryWiseSale();
    this.getTop3SellersWeb();

  }

  ngOnInit() {

    this.getCurrentFinancialYear();
    // this.startAutoPlay();


    const lastYearData = [100, 120, 140, 130, 200, 180, 190, 170, 210, 200, 230, 250];
    const currentYearData = [110, 130, 150, 140, 170, 190, 200, 180, 220, 210, 240, 260];

    this.prepareFinancialChart(lastYearData, currentYearData);

  }
  tabs = ['Sales', 'Enquiry'];
  // tabs = ['Sales', 'Enquiry', 'Sales Forecasting'];


  getTabValue(value) {
    this.tabValue = value.tab.textLabel;
    if (this.tabValue == 'Sales') {
      this.getSecondaryTarget();
      this.getPrimaryTarget();
      this.getCheckinCount();
      this.getCategoryWiseSale();
      this.getTop3SellersWeb();
    }


    if (this.tabValue == 'Enquiry') {
     this.getTotalEnquiry()
     this.getQualifiedEnquiry()
     this.getEnquiryCategoryCount()
      
    }

  }


  getPrimaryTarget() {
    this.serve.post_rqst({}, "Dashboard/primaryTargetVsAchWeb").subscribe(result => {

      if (result['statusCode'] == 200) {
        this.primaryTarget = result['primaryTarget']
      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    })

  }
  getSecondaryTarget() {
    this.serve.post_rqst({}, "Dashboard/secondaryTargetVsAchWeb").subscribe(result => {

      if (result['statusCode'] == 200) {
        this.secondaryTarget = result['secondaryTarget']

      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    })

  }
  getCheckinCount() {
    this.serve.post_rqst({}, "Dashboard/partyWiseVisitData").subscribe(result => {

      if (result['statusCode'] == 200) {
        this.checkinCount = result['result']
        this.checkinCountTotal = result['total']

      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    })

  }

  getCategoryWiseSale() {
    this.serve.post_rqst({}, "Dashboard/categoryWiseSale").subscribe(result => {

      if (result['statusCode'] == 200) {
        this.categoryWiseSales = result['categoryWiseSales']


      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    })

  }
  getTop3SellersWeb() {
    this.serve.post_rqst({}, "Dashboard/top3SellersWeb").subscribe(result => {

      if (result['statusCode'] == 200) {
        this.top3PrimaryAchievers = result['topAchievers']['top3PrimaryAchievers']
        this.top3SecondaryAchievers = result['topAchievers']['top3SecondaryAchievers']


      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    })

  }
    getTotalEnquiry() {
    this.serve.post_rqst({}, "Dashboard/totalEnquiry").subscribe(result => {

      if (result['statusCode'] == 200) {
        this.totalEnquiry = result['result']


      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    })

  }

     getQualifiedEnquiry() {
    this.serve.post_rqst({}, "Dashboard/qualifiedEnquiry").subscribe(result => {

      if (result['statusCode'] == 200) {
        this.totalQualifiedEnquiry = result['result']


      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    })

  }
       getEnquiryCategoryCount() {
    this.serve.post_rqst({}, "Dashboard/sourceWiseEnquiry").subscribe(result => {

      if (result['statusCode'] == 200) {
        this.sourceWiseConversion = result['result']
        this.sourceWiseConversionTotal = result['total']


      }
      else {
        this.toast.errorToastr(result['statusMsg'])
      }
    })

  }
  



  prepareFinancialChart(lastYearData: number[], currentYearData: number[]) {
    this.months = ['Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'];
    this.xGap = 60;

    const allData = lastYearData.concat(currentYearData);
    this.maxY = Math.max.apply(null, allData);
    this.minY = 0; // keep baseline zero

    // Generate Y-axis labels dynamically
    const steps = 5;
    const interval = Math.ceil((this.maxY - this.minY) / steps);
    this.yAxisLabels = [];

    for (let i = 0; i <= steps; i++) {
      const label = this.minY + (steps - i) * interval;
      const posY = 50 + i * 50; // Y position step
      this.yAxisLabels.push({ label, pos: posY });
    }

    // Generate polyline points
    const getPoints = (data: number[]) => {
      const chartHeight = 250;
      const baseY = 300;
      const range = this.maxY - this.minY || 1;

      return data
        .map((val, index) => {
          const x = 60 + index * this.xGap;
          const y = baseY - (val - this.minY) * (chartHeight / range);
          return `${x},${y}`;
        })
        .join(' ');
    };

    this.lastYearPoints = getPoints(lastYearData);    // Red line
    this.currentYearPoints = getPoints(currentYearData); // Blue line
  }



  getCurrentFinancialYear() {
    var fiscalyear = "";
    var today = new Date();
    if ((today.getMonth() + 1) <= 3) {
      fiscalyear = (today.getFullYear() - 1) + "-" + today.getFullYear()
    } else {
      fiscalyear = today.getFullYear() + "-" + (today.getFullYear() + 1)
    }
    this.financeyear = fiscalyear
  }

  getDegrees(percentage: number): number {
    return Math.round((percentage / 100) * 360);
  }

  startAutoPlay(): void {
    if (this.isAutoPlaying) {
      this.autoPlayInterval = setInterval(() => {
        this.nextSlide();
      }, this.SLIDE_DURATION);
    }
  }
  toggleAutoPlay(): void {
    this.isAutoPlaying = !this.isAutoPlaying;
    if (this.isAutoPlaying) {
      this.startAutoPlay();
    } else {
      this.stopAutoPlay();
    }
  }

  nextSlide(): void {
    if (this.isAnimating) return;

    this.isAnimating = true;
    this.currentIndex = (this.currentIndex + 1) % 2; // Only 2 cards now

    setTimeout(() => {
      this.isAnimating = false;
    }, 500);
  }

  prevSlide(): void {
    if (this.isAnimating) return;

    this.isAnimating = true;
    this.currentIndex = this.currentIndex === 0 ? 1 : 0;

    setTimeout(() => {
      this.isAnimating = false;
    }, 500);
  }

  goToSlide(index: number): void {
    if (this.isAnimating || index === this.currentIndex) return;

    this.isAnimating = true;
    this.currentIndex = index;

    // Reset auto-play timer
    if (this.isAutoPlaying) {
      this.stopAutoPlay();
      this.startAutoPlay();
    }

    setTimeout(() => {
      this.isAnimating = false;
    }, 500);
  }
  stopAutoPlay(): void {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }

  trackByFn(index: number, item: any): any {
    return item.party_type; // or item.id if you have one
  }

  getBarWidth(visitCount: number): number {
    const maxCount = Math.max.apply(Math, this.checkinCount.map(item => item.visit_count));
    return maxCount > 0 ? (visitCount / maxCount) * 100 : 0;
  }
   getBarWidthEnquiry(visitCount: number): number {
    return this.totalEnquiry.total > 0 ? (visitCount / this.totalEnquiry.total) * 100 : 0;
  }
   getQualifiedPercentage(visitCount: number): number {
    return this.totalQualifiedEnquiry.total > 0 ? (visitCount / this.totalQualifiedEnquiry.total) * 100 : 0;
  }
   getsourceWiseConversionPercentage(visitCount: number): number {
    return this.sourceWiseConversionTotal > 0 ? (visitCount / this.sourceWiseConversionTotal) * 100 : 0;
  }
}
